import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import isEqual from 'lodash-es/isEqual';
import {AuthService} from '../../shared/auth.service';

function shuffle(a: any[]) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
}

@Component({
  selector: 'talent-pool',
  templateUrl: './talent-pool.component.html',
  styleUrls: ['./talent-pool.component.scss']
})
export class TalentPoolComponent implements OnChanges {

  @Input() position: Order | null = null;
  @Input() submittals: Submittal[] = [];
  @Input() small = false;
  @Input() favorites: string[] = [];
  @Input() type: 'favorites' | null;

  @Output() favorite = new EventEmitter<{id: string, favorite: boolean}>();
  @Output() identify = new EventEmitter<{event?: Event, callback?: Function | null}>();

  count = 0;
  filtered: Submittal[] = [];
  user$ = this.Auth.user$;

  constructor(private Auth: AuthService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Perform deep equals on submittals so we don't shuffle needlessly
    const submittalsChange = changes['submittals'];
    if (this.submittals
      && ((submittalsChange && !isEqual(submittalsChange.previousValue, submittalsChange.currentValue))
        || changes['position'] || changes['small'])) {
      this.count = this.submittals.length;
      const filtered = this.submittals.slice();
      if (this.small) {
        shuffle(filtered);
        this.filtered = filtered.slice(0, 3);
      } else {
        this.filtered = filtered;
      }
    }
  }

  showIdentification(event?: Event, callback?: Function) {
    if (!this.Auth.isFullyAuthenticated()) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      this.identify.emit({event, callback});
    }
  }
}
